import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FragnoBadge } from 'fragno/react';
import style from '../../../style/components/profile/emails/DomainClassificationBadge.module.scss';

const BADGE_CONFIG = {
  personal: { color: 'success', labelKey: 'walletEmails.badgePersonal' },
  work: { color: 'success', labelKey: 'walletEmails.badgeWork' },
  unknown: { color: 'warning', labelKey: 'walletEmails.badgeUnknown' },
  malicious: { color: 'error', labelKey: 'walletEmails.badgeMalicious' },
};

const DomainClassificationBadge = ({ classification, domain }) => {
  const { t } = useTranslation();

  const config = BADGE_CONFIG[classification];

  if (!config) {
    // Render empty placeholder to reserve space and prevent layout jump
    return <div className={style.container} />;
  }

  const messageKey = `walletEmails.badgeMessage${
    classification.charAt(0).toUpperCase() + classification.slice(1)
  }`;

  return (
    <div className={style.container}>
      <FragnoBadge
        color={config.color}
        size="sm"
        label={t(config.labelKey)}
        data-testid="domain-classification-badge"
      />
      <p
        className={`${style.message} ${
          classification === 'malicious'
            ? style.messageMalicious
            : style.messageDefault
        }`}
      >
        {t(messageKey, { domain })}
      </p>
    </div>
  );
};

DomainClassificationBadge.propTypes = {
  classification: PropTypes.oneOf(['personal', 'work', 'unknown', 'malicious']),
  domain: PropTypes.string,
};

DomainClassificationBadge.defaultProps = {
  classification: null,
  domain: null,
};

export default memo(DomainClassificationBadge);
